import { connect } from 'react-redux'

import AvailabilityModal from '../../components/AvailabilityModal/AvailabilityModal'

const mapStateToProps = state => ({
  showLocalisationModal: state.application.availability.showLocalisationModal,
  localisationPostcode: state.application.availability.localisationPostcode,
  partNumber: state.product.products[0].id,
  pageType: state.application.pageType
})

export default connect(mapStateToProps)(AvailabilityModal)
